package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.network.ApiResult
import com.eladfinish.bible.contest.screens.chapterComplete.api.ChapterCompleteApi
import com.eladfinish.bible.contest.screens.chapterComplete.model.BlanksRecord

class GetPresetBlanksUseCase(
    private val chapterCompleteApi: ChapterCompleteApi,
    private val processRemoteBlanksUseCase: ProcessRemoteBlanksUseCase,
) {

    suspend operator fun invoke(): Pair<List<String>, List<BlanksRecord>> {
        return when (val content = chapterCompleteApi.getPresetBlanks()) {
            is ApiResult.ClientError -> emptyList<String>() to emptyList()
            is ApiResult.Failure -> emptyList<String>() to emptyList()
            is ApiResult.Success -> processRemoteBlanksUseCase(blanksData = content.data)
        }
    }

}
